import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store/store';

interface CableRequestState {
    list: any,
  }
  
const initialState:CableRequestState = {
    list:undefined,
}

export const cableRequestSlice = createSlice({
    name:"cableRequestList",
    initialState,
    reducers:{
        UpdatecableRequestList: (state,action) => {
            state.list = action.payload.cableRequestList;
        },
        AddcableRequest: (state,action) => {
            state.list = undefined;
        },
        EditcableRequest: (state,action) => {
            state.list = undefined;
        },
        RemovecableRequest: (state,action) => {
            state.list = undefined;
        }
    }
})

export const {UpdatecableRequestList,AddcableRequest,EditcableRequest,RemovecableRequest} = cableRequestSlice.actions

export const selectcableRequestList = (state: RootState) => state.cableRequestList

export default cableRequestSlice.reducer;